import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import t from 'format-message';
import { COMPLETED, ERROR } from "../constants.js";
import { showFlashAlert } from "../components/FlashAlert/index.js";
export var NOT_EXPORTING = 'not_exporting';
export var FETCHING_DATA = 'fetching_data';
export var FORMATTING_CSV = 'formatting_csv';
export var CSV_COMPLETE = 'csv_complete';
export var alertTypes = {
  starting: {
    message: t('CSV export has started. This may take a few minutes.'),
    type: 'success',
    timeout: 5000
  },
  cancelled: {
    message: t('Your CSV export has been cancelled'),
    type: 'info',
    timeout: 5000
  },
  success: {
    message: t('CSV export has completed'),
    type: 'success',
    timeout: 5000
  },
  error: {
    message: t('There was an error in fetching the data. Please try again.'),
    type: 'error',
    timeout: 5000
  }
};
var useCSVExport = function useCSVExport(_ref) {
  var fetchCSVData = _ref.fetchCSVData,
    fetchingStatus = _ref.fetchingStatus,
    formatCSVData = _ref.formatCSVData,
    showProgressBar = _ref.showProgressBar,
    hideProgressBar = _ref.hideProgressBar;
  var _useState = useState(NOT_EXPORTING),
    _useState2 = _slicedToArray(_useState, 2),
    exportState = _useState2[0],
    setExportState = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    formattedData = _useState4[0],
    setFormattedData = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    progressValue = _useState6[0],
    setProgressValue = _useState6[1];
  var incrementProgressValue = function incrementProgressValue() {
    return setProgressValue(function (prevValue) {
      return prevValue + 1;
    });
  };
  useEffect(function () {
    if (exportState === FETCHING_DATA && fetchingStatus === COMPLETED) {
      formatData();
    } else if (exportState === FETCHING_DATA && fetchingStatus === ERROR) {
      hideProgressBar();
      showFlashAlert(alertTypes.error);
      setExportState(NOT_EXPORTING);
    }
  }, [fetchingStatus]);
  useEffect(function () {
    if ((exportState === FETCHING_DATA || exportState === FORMATTING_CSV) && progressValue < 90) {
      setTimeout(function () {
        incrementProgressValue();
      }, 1);
    } else if (exportState === FORMATTING_CSV && formattedData.length > 0) {
      setProgressValue(100);
      showFlashAlert(alertTypes.success);
      setExportState(CSV_COMPLETE);
      setTimeout(function () {
        hideProgressBar();
        setExportState(NOT_EXPORTING);
      }, 3000);
    }
  }, [exportState, formattedData, progressValue]);
  var beginExport = function beginExport() {
    showProgressBar();
    showFlashAlert(alertTypes.starting);
    if (fetchingStatus === COMPLETED) {
      formatData();
    } else {
      fetchData();
    }
  };
  var cancelExport = function cancelExport() {
    showFlashAlert(alertTypes.cancelled);
    setExportState(NOT_EXPORTING);
    hideProgressBar();
  };
  var fetchData = function fetchData() {
    setExportState(FETCHING_DATA);
    fetchCSVData();
  };
  var formatData = function formatData() {
    setExportState(FORMATTING_CSV);
    setFormattedData(formatCSVData());
  };
  return {
    beginExport: beginExport,
    cancelExport: cancelExport,
    exportState: exportState,
    progressValue: progressValue,
    formattedData: formattedData
  };
};
useCSVExport.PropTypes = {
  fetchCSVData: PropTypes.func.isRequired,
  fetchingStatus: PropTypes.string.isRequired,
  formatCSVData: PropTypes.func.isRequired,
  showProgressBar: PropTypes.func.isRequired,
  hideProgressBar: PropTypes.func.isRequired
};
export default useCSVExport;